import React, { useState } from "react";
import DayTimetable from "../../Components/dayTimetable";
import DateSelector from "../../Components/dateSelector";
import { Toggle } from "@carbon/react";

export default function TeacherToday({ selectedClass }) {
    const [today, setToday] = useState(new Date());
    const [dayData, setDayData] = useState(null);
    const [fullView, setFullView] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    
    // Handle date and day data change from DateSelector
    const handleDateChange = (date, dayData) => {
        setToday(date);
        setDayData(dayData);
        setLoading(false);
        setError(null);
    };

    if (!selectedClass) {
        return (
            <section className="container mx-auto">
                <p className="text-gray-600 mb-4">
                    Bitte wählen Sie eine Klasse aus, um den Tagesübersicht-Inhalt anzuzeigen.
                </p>
            </section>
        );
    }

    if (loading) {
        return (
            <section className="container mx-auto">
                <p className="text-gray-600 mb-4">Loading...</p>
            </section>
        );
    }

    if (error) {
        return (
            <section className="container mx-auto">
                <p className="text-red-600 mb-4">Error fetching data: {error.message}</p>
            </section>
        );
    }

    return (
        <section className="container mx-auto">
            <div className="my-6 flex justify-between items-center">
                <DateSelector onDateChange={handleDateChange} />
                <div className="toggle-wrapper ">
                    <Toggle
                        id="toggle-3"
                        labelText="Volle Ansicht"
                        labelA={null}
                        labelB={null}
                        toggled={fullView}
                        onToggle={() => setFullView(!fullView)}
                    />
                </div>
            </div>
            {dayData?.holiday ? (
                <div className="flex justify-center items-center h-64">
                    <p className="text-center text-lg">{dayData.holiday.name}</p>
                </div>
            ) : (
                <div className="">
                    <DayTimetable
                        selectedClass={selectedClass}
                        date={today}
                        weekIndex={dayData?.weekNumber}
                        dayIndex={dayData?.dayOfWeek}
                        fullView={fullView}
                    />
                </div>
            )}
        </section>
    );
}
